<template>
	<div class="mobile-tab" :class="styleType === 'text' ? 'text-style' : 'block-style'">
		<div class="tab-wrapper">
			<div
				v-for="(item, index) in option"
				:key="index"
				class="tab-item"
				:class="{ 'tab-item--active': item.value == innerValue }"
				@click="changeTab(item, index)"
			>
				{{ item.label }}
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
	value: {
		// eslint-disable-next-line vue/require-prop-type-constructor
		type: String | Number,
		default: ''
	},
	option: {
		type: Array,
		default: () => []
	},
	styleType: {
		type: String,
		default: 'block', // 'block' | 'text'
		validator: value => ['block', 'text'].includes(value)
	}
});
const emits = defineEmits(['change', 'update:value']);
const innerValue = computed({
	get: () => props.value,
	set: val => {
		emits('update:value', val);
	}
});
const changeTab = (item, idx) => {
	if (innerValue.value == item.value) return;
	innerValue.value = item.value;
	emits('change', {
		index: idx,
		value: item.value,
		data: props.option[idx]
	});
};
</script>

<style lang="less" scoped>
.mobile-tab {
	// Block 样式 - 矩形块状
	&.block-style {
		.tab-wrapper {
			display: flex;
			white-space: nowrap;
			overflow: auto;

			.tab-item {
				padding: 0 12px;
				height: 28px;
				border-radius: 2px;
				background: var(--fill-normal-color);
				color: var(--secondary-info-color);
				font-size: 12px;
				font-weight: 400;
				display: flex;
				align-items: center;

				& + .tab-item {
					margin-left: 8px;
				}

				&--active {
					color: var(--theme-color);
					font-weight: 500;
					background: linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 100%),
						var(--theme-color);
				}
			}

			&::-webkit-scrollbar {
				display: none;
			}
		}
	}

	// Text 样式 - 文本线条
	&.text-style {
		.tab-wrapper {
			display: flex;
			gap: 24px;
			padding: 8px 16px;
			overflow: visible;

			.tab-item {
				padding: 0 0 8px 0;
				height: auto;
				background: transparent;
				color: var(--t-secondary-color, #4e5969);
				font-size: 14px;
				font-weight: 400;
				line-height: 18px;
				position: relative;
				display: flex;
				align-items: center;

				&--active {
					color: var(--t-emphasis-color, #1d2129);
					font-size: 16px;
					font-weight: 600;

					&::before {
						content: '';
						width: 8px;
						height: 2px;
						border-radius: 8px;
						background: var(--t-emphasis-color, #1d2129);
						position: absolute;
						bottom: 0;
						left: 50%;
						margin-left: -4px;
					}
				}
			}
		}
	}
}
</style>
